import React, { useEffect, useState } from "react";
import BestuursinfoModal from "Components/Modal/BestuursinfoModal";
import PlanscreenService from "Api/Verzoeken/Planscreen";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

function SchoolInfoModal({ isOpen, onClose, text = {} }) {
  return (
    <BestuursinfoModal
      modal={isOpen}
      header1="Bestuursinformatie"
      header2="Schoolinformatie"
      headerColor=""
      toggle={onClose}
      showFooterBtns={false}
      classes="modal-dialog__over feedback-modal-style planscreen__modal planscreen__modal--memo wc-500"
      content1={text.bestuur}
      content2={text.school}
    />
  );
}

export default function Bestuursinfo({ dayId, schoolInfoModalOpen, setSchoolInfoModalOpen, subsId }) {
  const [modals, setModals] = useState({
    schoolInfo: false,
    schoolInfoText: { bestuur: undefined, school: undefined },
  });
  const [isLoading, setIsLoading] = useState(false);
  const [hasData, setHasData] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const substitutionId = params.id || '';
  useEffect(() => {
    if (hasData) {
      setModals((prev) => ({ ...prev, schoolInfo: schoolInfoModalOpen }));
    } else {
      setModals((prev) => ({ ...prev, schoolInfo: false }));
      setSchoolInfoModalOpen(false);
    }
  }, [schoolInfoModalOpen, hasData]);

  const cleanText = (text) => {
    if (!text || typeof text !== "string") return undefined;
    return text
      .replace(/<p>|<\/p>|\r\n|&nbsp;/g, "")
      .replace(/\s+/g, " ")
      .trim();
  };

  const fetchDetails = () => {
    if (!dayId || isLoading) return;
    setIsLoading(true);
    const url = `${dayId}?substitutionId=${substitutionId}&page=1&pageSize=150`;
    PlanscreenService.getDetails(url)
      .then((res) => {
    
          if (res?.error === "invalid_link") {
        console.error("403 Forbidden - Invalid Link");
        navigate('/no-page-found')
        return; 
      }
       
        const payload = res?.data?.data;
        const memo = cleanText(payload?.memo ?? payload?.community?.memo);
        const memoSchoolPlanning = cleanText(
          payload?.school?.tSchool_memo
        );
        const showInfoForPlanning = payload?.showInfoForPlanning ?? payload?.community?.showInfoForPlanning;

        setModals((prev) => ({
          ...prev,
          schoolInfoText: {
            bestuur: memo,
            school: memoSchoolPlanning,
          },
        }));

        const hasContent = (memo && memo !== "") || (memoSchoolPlanning && memoSchoolPlanning !== "");

        setHasData(hasContent);

        if (hasContent && showInfoForPlanning === "Yes") {
          setSchoolInfoModalOpen(true);
        } else {
          setSchoolInfoModalOpen(false);
        }
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchDetails();
  }, [dayId]);

  return (
    <>
      {isLoading && (
        <div className="text-center">
          <span>Loading...</span>
        </div>
      )}
      {hasData && (
        <SchoolInfoModal
          isOpen={modals.schoolInfo}
          onClose={() => {
            setModals((prev) => ({ ...prev, schoolInfo: false }));
            setSchoolInfoModalOpen(false);
          }}
          text={modals.schoolInfoText}
        />
      )}
    </>
  );
}